import { useNavigate } from 'react-router-dom';

const faqs = [
  {
    q: '非麻瓜漫画是什么？',
    a: '非麻瓜漫画是一个专注于魔法、奇幻和异能题材的免费漫画阅读平台。我们为读者提供下拉式阅读体验，让你可以一口气畅读完整篇章。无论你喜欢魔法学院、奇幻冒险还是都市异能，都能在这里找到心仪的漫画作品。',
  },
  {
    q: '非麻瓜漫画是否完全免费？',
    a: '是的，非麻瓜漫画上所有漫画作品均免费向读者开放。我们致力于为漫画爱好者提供一个无障碍的阅读平台，无需付费即可畅享全部内容。下拉式阅读模式让你获得沉浸式的阅读体验。',
  },
  {
    q: '支持哪些设备阅读？',
    a: '非麻瓜漫画完美适配电脑、平板和手机等各类设备。我们采用响应式设计，无论你使用什么设备访问，都能获得流畅舒适的阅读体验。下拉式阅读模式在移动设备上尤其便捷，轻松滑动即可连续阅读。',
  },
  {
    q: '如何找到我想看的漫画？',
    a: '你可以通过顶部的分类导航浏览不同题材的漫画，包括魔法漫画、奇幻漫画、异能漫画、冒险漫画、玄幻漫画和都市异能。也可以使用搜索功能直接查找你喜欢的作品。首页还会定期更新推荐和排行榜。',
  },
  {
    q: '漫画更新频率怎么样？',
    a: '我们合作的创作者保持稳定的更新节奏，大部分连载作品每周更新一章。你可以关注喜欢的漫画，第一时间获取更新通知。首页的「最新更新」榜单也能帮你追踪热门漫画的最新章节。',
  },
  {
    q: '可以投稿或合作吗？',
    a: '非常欢迎！如果你是漫画创作者，可以通过关于我们页面的联系方式与我们取得联系。我们支持原创漫画作者的投稿，也欢迎各类商务合作。非麻瓜漫画期待与更多优秀的创作者携手前行。',
  },
];

export default function FAQSection() {
  const navigate = useNavigate();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于非麻瓜漫画，你可能想了解的事情
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                <h4 className="font-heading font-medium text-foreground-950 text-sm md:text-base pr-4">
                  {faq.q}
                </h4>
                <div className="w-6 h-6 flex items-center justify-center shrink-0 rounded-full bg-background-100 group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform"></i>
                </div>
              </summary>
              <div className="px-6 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-foreground-500 text-sm mb-4">还有其他问题？欢迎联系我们的客服团队</p>
          <button
            onClick={() => navigate('/about')}
            className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            联系我们
          </button>
        </div>
      </div>
    </section>
  );
}